import { cmsStrings } from "../terminology";

type Props = {
  /** `rail` = Quiet Cobalt mist nav brand; `auth` = login/MFA pages. */
  variant?: "auth" | "rail";
  titleId?: string;
};

export function AuthBrand({ variant = "auth", titleId }: Props) {
  if (variant === "rail") {
    return (
      <div className="brand-block" data-vt-auth-brand="rail">
        <p className="brand-en" dir="ltr">
          {cmsStrings.brand.nameEn}
        </p>
        <p className="brand-title" id={titleId}>
          {cmsStrings.brand.productTitle}
        </p>
        <span className="brand-accent" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="auth-brand" data-vt-auth-brand="auth">
      <p className="auth-brand__en" dir="ltr">
        {cmsStrings.brand.nameEn}
      </p>
      <h2 className="auth-brand__title">{cmsStrings.brand.productTitle}</h2>
    </div>
  );
}
